if (!customElements.get('blog-slider')) {
    class BlogSlider extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-blog__items',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
  
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.space = parseInt(this.dataset.space);
        this.spaceMb = parseInt(this.dataset.spaceMb);
  
        this.sliderInstance = false;
  
        if (!this.enableSlider) return;
  
        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }
  
      init() {
        this.initSlider();
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }
  
      initSlider() {
        const sliderOptions = {
          modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
          slidesPerView: 1.39,
          spaceBetween: this.spaceMb,
          pagination: false,
          breakpoints: {
            1280: {
              slidesPerView: parseInt(this.items),
              spaceBetween: this.space,
            },
          },
          loop: false,
        };
  
        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
          this.sliderInstance.init();
  
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
  
          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            });
          });
        }
      }
  
      destroySlider() {
      }
    }
    customElements.define('blog-slider', BlogSlider);
  }
  